import type { enCard } from "./en.card";

/** Russian for the campaign card (see `en.card.ts`). Words from the boards CSummary … CEmpty. */
export const ruCard: Record<keyof typeof enCard, string> = {
  "card.meta.domain": "домен",
  "card.menu.pause": "Поставить на паузу",
  "card.menu.copyLink": "Скопировать ссылку",
  "card.menu.report": "Открыть в отчётах",
  "card.toast.linkCopied": "Ссылка скопирована",
  "card.archive.title": "Архивировать кампанию?",
  "card.archive.stops": "Ссылка перестанет работать",
  "card.archive.stops.body": "Люди из объявлений {source} больше не попадут в кампанию. Объявления в кабинете продолжат тратить — остановите их там.",
  "card.archive.today": "Сегодня",
  "card.archive.today.value": "{clicks} кликов, {leads} лидов, расход {cost}",
  "card.archive.hold": "{n} лидов — постбеки продолжат приниматься",
  "card.archive.stats": "Статистика",
  "card.archive.stats.value": "остаётся в отчётах, кампанию можно вернуть из архива",
  "card.archive.cancel": "Отмена",
  "card.archive.confirm": "Архивировать",

  "card.kpi.aria": "Цифры кампании за период",
  "card.kpi.botsCut": "боты {pct} отсеяны",
  "card.kpi.inTransit": "≈ {sum} в пути",
  "card.kpi.waitFirst": "ждём первый",
  "card.kpi.costFromSource": "из источника",

  "card.path.bots.share": "{pct} — краулеры, дата-центры",
  "card.path.shows.note": "{pct} дошли до страницы",
  "card.path.cta.share": "LP CTR {pct}",
  "card.path.lead.share": "CR {cr} от людей",
  "card.path.approve.share": "{pct} из решённых",

  "card.outcome.aside": "{n} лидов за период",
  "card.outcome.approved": "Апрувы",
  "card.outcome.approved.why": "засчитаны, деньги пришли",
  "card.outcome.hold": "Холд",
  "card.outcome.hold.why": "ждут решения партнёрки",
  "card.outcome.rejected": "Отказы",
  "card.outcome.rejected.why": "недозвон, отказ, дубль",
  "card.outcome.trash": "Треш",
  "card.outcome.trash.why": "фейк-номер, не та страна",
  "card.outcome.age.fresh": "до суток",
  "card.outcome.age.mid": "1–3 дня",
  "card.outcome.age.old": "дольше 3 дней",

  "card.insight.aside.compare": "за период, к прошлым {days} дням",
  "card.insight.openReport": "Открыть отчёт",
  "card.insight.show": "Показать",

  "card.empty.title": "Ждём первый клик",
  "card.empty.body": "Ссылка готова. Как только человек нажмёт на объявление, здесь появятся клики, путь и деньги — обновляется само, страницу перезагружать не нужно.",
  "card.empty.cost": "Расход из {source} подтянется, когда объявления начнут тратить",
  "card.empty.test": "Тестовый клик",
  "card.ready.title": "Готовность",
  "card.ready.count": "{done} из {total}",
  "card.ready.done": "сделано",
  "card.ready.todo": "осталось",
  "card.ready.created": "Кампания создана",
  "card.ready.domain": "Домен {fqdn} отвечает",
  "card.ready.domain.none": "У кампании нет домена",
  "card.ready.domain.ok": "HTTPS, отдаёт edge",
  "card.ready.domain.wait": "ещё не отдаёт — привязка проверяется",
  "card.ready.postback": "Партнёрка знает постбек",
  "card.ready.postback.none": "у кампании нет партнёрки",
  "card.ready.postback.seen": "{network}: постбек пришёл {ago} назад",
  "card.ready.postback.wait": "{network}: вставьте адрес в кабинет и отправьте тест",
  "card.ready.test": "Тестовый клик",
  "card.ready.test.why": "проверит правила и ленд так, как их увидит человек",
  "card.ready.test.done": "дошёл {ago} назад",
  "card.ready.test.go": "Сделать тестовый клик",
  "card.ready.ads": "Ссылка в объявлениях {source}",
  "card.ready.ads.why": "вставьте ссылку в поле «URL сайта» — первый клик появится здесь через пару секунд",
  "card.ready.ads.copy": "Скопировать ссылку",
  "card.ready.hint": "Карточка сама перейдёт к цифрам на первом визите.",

  "card.filter.add": "Фильтр",
  "card.filter.facets": "Фильтры",
  "card.filter.search": "Поиск",
  "card.filter.apply": "Применить",
  "card.filter.reset": "Сбросить",
  "card.filter.none": "Ничего не нашлось",
  "card.filter.back": "Назад",
  "card.filter.active": "Применённые фильтры",
  "card.filter.remove": "Убрать фильтр «{facet}»",
  "card.filter.edit": "Изменить фильтр «{facet}»",

  "card.conv.leadAt": "Время лида",
  "card.conv.payout": "Выплата",
  "card.conv.usd": "В USD",
  "card.conv.txidNet": "ID в сети",
  "card.conv.city": "Город",
  "card.conv.click": "Клик",
  "card.conv.waits": "ждёт {n}",
  "card.conv.caption": "Время — по поясу {tz} · статус обновляет постбек партнёрки",
  "card.conv.total": "Итого, {n} {leads}",
  "card.conv.empty": "За период конверсий нет",

  "card.clicks.segments": "Какие визиты",
  "card.clicks.seg.all": "Все",
  "card.clicks.seg.people": "Люди",
  "card.clicks.seg.bots": "Боты",
  "card.clicks.seg.leads": "С лидом",
  "card.clicks.device": "Устройство",
  "card.clicks.went": "Куда попал",
  "card.clicks.result": "Итог",
  "card.clicks.live": "живьём · новые сверху",
  "card.clicks.newest": "новые сверху",

  "card.flow.lead": "Посетитель идёт по правилам сверху вниз; первое совпавшее решает. Остальные — по долям.",
  "card.flow.handBuilt": "Кампания идёт по схеме, собранной вручную; её меняет админ.",
  "card.flow.rules": "Правила потока",
  "card.flow.rules.aside": "проверяются сверху вниз · визиты за период",
  "card.flow.rest": "Остальные —",
  "card.flow.rest.shares": "по долям ниже",
  "card.flow.toOffer": "Оффер",
  "card.flow.toPage": "Страница",
  "card.flow.toUrl": "Ссылка",
  "card.flow.exits": "Выходы со страницы",
  "card.flow.exits.aside": "ветки · показы",
  "card.flow.exits.note": "Срабатывают на ленде, если человек не нажал кнопку. Без ветки он просто уходит.",
  "card.flow.unset": "не задано",
  "card.flow.nextStep": "Второй шаг",
  "card.flow.offerDirect": "оффер {name} напрямую",
  "card.flow.offer": "Оффер",
  "card.flow.offers.count": "офферов: {n}",
  "card.flow.landers": "Ленды",
  "card.flow.landers.count": "лендов: {n} · доли суммируются в 100%",
  "card.flow.where": "Куда",
  "card.flow.share": "Доля",
  "card.flow.people": "Люди",
  "card.flow.ctas": "кнопок: {n}",
  "card.flow.thanks": "Страница «Спасибо»",
  "card.flow.thanks.default": "по умолчанию пространства",

  "card.links.for": "Ссылка для {source}",
  "card.links.domainOk": "Домен отвечает",
  "card.links.domainWait": "Домен ещё не отдаёт",
  "card.links.test": "Тестовый клик",
  "card.links.test.hint": "откроет ссылку с вашей тестовой меткой и покажет, куда он попал",
  "card.links.mark": "Метка",
  "card.links.fills": "Что подставит {source}",
  "card.links.macro": "Макрос",
  "card.links.adId": "· объявление, для расхода",
  "card.links.postbackFor": "Постбек для {network}",
  "card.links.postback.aside": "вставьте в кабинет партнёрки",
  "card.links.lastReal": "последний настоящий — {ago} назад",
  "card.links.word": "Статус партнёрки",
  "card.links.ours": "У нас",
  "card.links.inSource": "В {source}",
  "card.links.toSource": "Отправка в {source}",
  "card.links.capi.road": "Трекер сам ничего не шлёт в источник: решение партнёрки идёт дорогой Keitaro в Conversions API.",
  "card.links.journal": "Весь журнал",

  "card.settings.oneForm.full": "Кампания меняется в одном месте — в редакторе. Здесь только то, как она настроена сейчас.",
  "card.settings.openEditor": "Открыть редактор",
  "card.settings.source": "Источник",
  "card.settings.domain": "Домен и адрес",
  "card.settings.key": "Ключ",
  "card.settings.key.without": "без него — страница правила",
  "card.settings.cost": "Расход",
  "card.settings.cost.how": "Как считаем",
  "card.settings.cost.from": "Откуда",
  "card.settings.cost.auto": "{source}, по объявлениям",
  "card.settings.tech": "Технические",
  "card.settings.id": "ID кампании",
  "card.settings.created": "Создана",
  "card.settings.version": "Версия",
  "card.settings.history": "история",

  "card.history.kinds": "Какие изменения",
  "card.history.kind.all": "Все",
  "card.history.kind.flow": "Поток",
  "card.history.kind.links": "Ссылки",
  "card.history.kind.status": "Статус",
  "card.history.kind.cost": "Расход",
  "card.history.verb.create": "создание кампании",
  "card.history.verb.update": "изменение",
  "card.history.verb.pause": "пауза",
  "card.history.verb.activate": "включение",
  "card.history.verb.archive": "в архив",
  "card.history.verb.duplicate": "копия",
  "card.history.field.domain": "Домен",
  "card.history.who": "Кто",
  "card.history.caption": "все изменения кампании и кто их сделал · хранится всегда",
  "card.history.compare": "Сравнить",
  "card.history.compare.title": "Что сделало это изменение",
  "card.history.compare.same": "Ничего не отличается",
  "card.history.rules": "правил: {n}",
  "card.history.branches": "веток: {n}",

  "click.drawer.title": "Клик",
  "click.drawer.id": "id клика",
  "click.drawer.conversions": "Конверсии клика",
  "click.drawer.json": "Скопировать как JSON",
  "click.drawer.prev": "Клик выше",
  "click.drawer.next": "Клик ниже",
  "click.chip.lander": "Ленд {name}",
  "click.chip.cta": "Кнопка",
  "click.chip.offer": "Оффер {name}",
  "click.chip.lead": "Лид → {status}",
  "click.how.rule": "Попал по правилу {n}: если {cond}",
  "click.how.shares": "Попал по долям",
  "click.how.sharesAfter": "Попал по долям: правила 1–{n} не сработали",
  "click.conversions.title": "Конверсии этого клика",
  "click.conv.after": "через {gap} после клика",
  "click.conv.txid": "ID в сети {txid}",
  "click.conv.byPostback": "по постбеку партнёрки",
  "click.who.class": "Класс",
  "click.who.score": "{n} из 100",
  "click.who.geo": "Гео",
  "click.marks": "Метки из объявления",

  "word.leads": "лид|лида|лидов",
};
